<template>
    <div class="content-item">
        <div class="content-item-value">
            <slot></slot>
        </div>
        <div v-if="state === 1" class="content-item-status published">Published</div>
        <div v-if="state === 0" class="content-item-status draft">Draft</div>
        <div
            v-if="typeof config.menu !== 'undefined' && config.menu === true"
            v-click-outside="menuClose"
            class="content-item-menu"
        >
            <div class="content-item-menu-dots" @click="menuToggle">
                <span class="dots"></span>
            </div>
            <ul v-if="menuIsOpen" :class="{ 'content-item-menu-items': true, 'open': menuIsOpen }">
                <li
                    v-if="typeof config.changeState !== 'undefined' && config.changeState === true && state === 0"
                    @click="menuClickEvent('activate')"
                >
                    {{ $t('components.list.menu_activate') }}
                </li>
                <li
                    v-if="typeof config.changeState !== 'undefined' && config.changeState === true && state === 1"
                    @click="menuClickEvent('deactivate')"
                >
                    {{ $t('components.list.menu_deactivate') }}
                </li>
                <li
                    v-if="typeof config.edit !== 'undefined' && config.edit === true"
                    @click="menuClickEvent('edit')"
                >
                    {{ $t('components.list.menu_edit') }}
                </li>
                <li
                    v-if="typeof config.delete !== 'undefined' && config.delete === true"
                    @click="menuClickEvent('delete')"
                >
                    {{ $t('components.list.menu_delete') }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListItem',
    props: {
        config: {
            type: Object,
            default: () => ({
                menu: false,
                changeState: false,
                edit: false,
                delete: false,
            }),
        },
        state: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            menuIsOpen: false,
        };
    },
    methods: {
        menuClose() {
            this.menuIsOpen = false;
        },
        menuToggle() {
            this.menuIsOpen = !this.menuIsOpen;
        },
        menuClickEvent(eventName) {
            this.menuIsOpen = false;
            this.$emit(eventName);
        },
    },
};
</script>
